import React, { useState, useEffect } from "react";
import { Link } from "@StarberryUtils";
import "./TabSearchResult.scss";
// import PlayVideo from "../../../Components/Play/PlayVideo";
import ScrollAnimation from "react-animate-on-scroll";
import FsLightbox from 'fslightbox-react';
import 'react-image-lightbox/style.css';
import CustomVideoPlay from "@Components/CustomVideo/CustomVideo.js";
import { ShowProcessedImage } from '../../common/stb-jamstack-ggfxclient/module/components/image/show-image';
import imageConfig from "../../../../static/images/config.json"
import noImage from "../../../images/no-image.png"
import { map } from "jquery";
import ModelForm from "@Components/ModelForm/ModelForm";
import Email from "../../../images/phone.svg"
import { useQuery } from '@apollo/client';
import { useStaticQuery, graphql } from "gatsby";
import gql from "graphql-tag";
import { SaveItem, UserObjectStoreProvider } from "@starberry/myaccount-website-utils";
import HTMLReactParser from 'html-react-parser'

import {ImageModule} from "@Components/common/Image_Module";


export const uknumberformat = (x) => {
  if (!x) return x;
  const currentValue = x.toString().replace(/[^\d]/g, '');
  return `${currentValue.slice(0, 5)} ${currentValue.slice(5, 11)}`;
}
const GET_ALL_TEAMS = gql`
  query GetTeam{
    teams(where: {Publish:true}, sort: "createdAt:asc") {
      id
      imagetransforms
      ggfx_results {
        id
        content_type
        transforms
        src_import_url
        src_cftle
        field
      }
      Repeat_Id
      Name
      Designation
      Email
      Phone
      Book_A_Video
      Image {
        alternativeText
        url
      }
    }
  }
`
const NewTabSearch = (props) => {
  const { data } = useQuery(GET_ALL_TEAMS)
  const officedata = useStaticQuery(graphql`
  query{
    glstrapi {
      offices(publicationState: LIVE, where: {Publish: true}) {
          id
          imagetransforms
          ggfx_results {
            id
            content_type
            transforms
            src_import_url
            src_cftle
            field
          }
          Office_Email
          Office_Address
          Office_Name
          Sales_Phone
          Lettings_Phone
          Office_Image {
              alternativeText
              url
          }
          URL

      }
    }
  }
  `);
  // console.log(officedata)
  const [isPlay, setPlay] = useState(false);
  const [property_rezise_images, setPropertyReziseImages] = useState("")
  const [negoid, setNegoid] = useState("")
  const [negoimagetransforms, setNegoimagetransforms] = useState("")

  useEffect(() => {
    if (data && data.teams && data.teams.length > 0 && props?.negotiator_details) {
      for (var i = 0; i < data.teams.length; i++) {
        if (props.negotiator_details?.id === data.teams[i].Repeat_Id || props.negotiator_details?.email === data.teams[i].Email) {
          setPropertyReziseImages(data.teams[i].Image)
          setNegoid(data.teams[i].id)
          setNegoimagetransforms(data.teams[i].ggfx_results)
        } else if (props?.negotiator_details?.ID?.value === data.teams[i].Repeat_Id || props?.negotiator_details?.Email?.value === data.teams[i].Email) {
          setPropertyReziseImages(data.teams[i].Image)
          setNegoid(data.teams[i].id)
          setNegoimagetransforms(data.teams[i].ggfx_results)
        } else if ("david@collegeandcounty.co.uk" === data.teams[i].Email) {
          setPropertyReziseImages(data.teams[i].Image)
          setNegoid(data.teams[i].id)
          setNegoimagetransforms(data.teams[i].ggfx_results)
        } else if ("David Gilson" === data.teams[i].Name) {
          setPropertyReziseImages(data.teams[i].Image)
          setNegoid(data.teams[i].id)
          setNegoimagetransforms(data.teams[i].ggfx_results)
        }
      }
    }
  }, [data])

// let processedImages = JSON.stringify({});
// if (negoimagetransforms?.Image_Transforms) {
//     processedImages = negoimagetransforms.Image_Transforms;
// }

  // Banner lightbox
  // const [photoIndex, setPhotoIndex] = useState(0);
  // const [isBannerOpen, setIsBannerOpen] = useState(false);

  // const openLighboxMobile = (e, ind) => {
  //     e.preventDefault();
  //     setPhotoIndex(ind);
  //     setIsBannerOpen(true);
  // }

  // var lightImagesProperty = []

  // if (props?.ImageMain) {
  //   props?.ImageMain.map( (img) => {
  //     console.log("$$$$$", img)
  //   } )

  //   lightImagesProperty = props?.ImageMain && props?.ImageMain.length > 0 && props?.ImageMain?.map(img => img['640x424']);
  // }
  // console.log("$$$$$$", lightImagesProperty)
  // Banner lightbox

  // Floorplan lightbox
  const [floorToggler, setFloorToggler] = useState(false);

  // const [floorplanIndex, setFloorplanIndex] = useState(0);
  // const [isFloorplanOpen, setIsFloorplanOpen] = useState(false);

  // const openLighboxMobileFloorplan = (e, ind) => {
  //     e.preventDefault();
  //     setFloorplanIndex(ind);
  //     setIsBannerOpen(true);
  // }

  // var lightImagesFloorplan = props?.FloorplanImg && props?.FloorplanImg;
  // Floorplan lightbox

  // Banner
  const [bannerToggler, setBannerToggler] = useState(false);

  var lightImagesProperty = []

  // useEffect(() => {
    if (props?.images) {
      props?.images.map( (img) => {
        // console.log("%%%%%", img)
        img?.map( (bannerImg) => {
          if(bannerImg['640x424']) {
            lightImagesProperty.push(bannerImg['640x424'])
          }
          if(bannerImg['222x140']) {
            lightImagesProperty.push(bannerImg['222x140'])
          }
        })
      } )
    }
  // }, [])

  //console.log("$$$$$", property_rezise_images)

  return (
    <React.Fragment>
      <UserObjectStoreProvider>
      {/* <ScrollAnimation animateOnce={true} animateIn="fadeIn"> */}
        <div id={`item${props.objectID}`} className="search-result-main-item">
            <div className="search-result-images">
              <div className="search-result-single-image img-hover-zoom">
              {props.studentProperty ? <> <div className="sold-cls d-flex align-items-center">Student Property</div> {props.status ?
                          <div className="status-blk black">
                          {props.status}
                          </div>
                          : null} </> : props.status ? <div className="sold-cls d-flex align-items-center">{props.status}</div> : null}
                {
                  props.images && props.images[0]?.length > 0 ?
                  <Link
                  onClick={() => {sessionStorage.setItem('searchindex', props.objectID)}}
                  to={props.PropertyDetailsUrl}>
                    <ShowProcessedImage images={props.images[0][0]} attr={{ className: 'mb-0 img-fluid', alt: '' }} transforms={imageConfig.property.searchResults.sizes} />
                  </Link>
                  :
                  <Link to={props.PropertyDetailsUrl}
                  onClick={() => {sessionStorage.setItem('searchindex', props.objectID)}}
                  >
                    <picture>
                      <img src={noImage} alt="" />
                    </picture>
                  </Link>
                }
                <div className="icon-group">
                  <ul>
                    {
                      props.FloorplanImg ?
                      <li>
                        <a href="javascript:void(0)" onClick={() => setFloorToggler(!floorToggler)}>
                          <i className="icon-production"></i>
                        </a>
                      </li>
                      : ''
                    }
                    {
                      props.videoid ?
                      <>
                        {/* <li
                          onClick={(e) => {
                            setPlay(true);
                          }}
                        >
                          <i className="icon-video-dark"></i>
                        </li> */}
                        <CustomVideoPlay small={true} url={props.videoid} />
                      </>
                      : ''
                    }
                    {
                      props.images ?
                      <>
                        <li>
                          <a href="javascript:void(0)" onClick={() => setBannerToggler(!bannerToggler)}>
                          <i className="icon-gallery"></i>
                          </a>
                        </li>
                        <li>{props.ImgGalleryNumber}</li>
                      </>
                      : ''
                    }
                  </ul>
                </div>
              </div>
              <div className="search-result-grid-images">
                <div className="search-result-grid-image-single img-hover-zoom">
                  {
                    props.ListImageGrid1 && props.ListImageGrid1.length !=0 ?
                    <Link to={props.PropertyDetailsUrl}
                    onClick={() => {sessionStorage.setItem('searchindex', props.objectID)}}>
                      <ShowProcessedImage images={props.ListImageGrid1} attr={{ className: 'mb-0 img-fluid', alt: '' }} transforms={imageConfig.property.searchResults2.sizes} />
                    </Link>
                    :
                    <Link to={props.PropertyDetailsUrl}
                    onClick={() => {sessionStorage.setItem('searchindex', props.objectID)}}>
                      <picture>
                        <img src={noImage} alt="" />
                      </picture>
                    </Link>
                  }
                </div>
                <div className="search-result-grid-image-single img-hover-zoom">
                  {
                    props.ListImageGrid2 && props.ListImageGrid2.length !=0 ?
                    <Link to={props.PropertyDetailsUrl}
                    onClick={() => {sessionStorage.setItem('searchindex', props.objectID)}}>
                      <ShowProcessedImage images={props.ListImageGrid2} attr={{ className: 'mb-0 img-fluid', alt: '' }} transforms={imageConfig.property.searchResults2.sizes} />
                    </Link>
                    :
                    <Link to={props.PropertyDetailsUrl}
                    onClick={() => {sessionStorage.setItem('searchindex', props.objectID)}}>
                      <picture>
                        <img src={noImage} alt="" />
                      </picture>
                    </Link>
                  }
                </div>
                <div className="search-result-grid-image-single img-hover-zoom">
                  {
                    props.ListImageGrid3 && props.ListImageGrid3.length !=0 ?
                    <Link to={props.PropertyDetailsUrl}
                    onClick={() => {sessionStorage.setItem('searchindex', props.objectID)}}>
                      <ShowProcessedImage images={props.ListImageGrid3} attr={{ className: 'mb-0 img-fluid', alt: '' }} transforms={imageConfig.property.searchResults2.sizes} />
                    </Link>
                    :
                    <Link to={props.PropertyDetailsUrl}
                    onClick={() => {sessionStorage.setItem('searchindex', props.objectID)}}>
                      <picture>
                        <img src={noImage} alt="" />
                      </picture>
                    </Link>
                  }
                </div>
              </div>
            </div>


          <div className="search-result-text-content">

            <Link to={props.PropertyDetailsUrl}
            onClick={() => {sessionStorage.setItem('searchindex', props.objectID)}}>
            <div className="price-guide">
              <span className="price">&#163;{props.ItemPrice}</span>
              {props.searchType === "lettings" ? <span className="guide-text">PCM</span> : props.searchType === "sales" ? <span className="guide-text">{props.ItemGuideText}</span> : null}
            </div>
            <p className="item-address">{props.ItemAddress}</p>
            <p className="item-small-description">{props.ItemSmallDescription}</p>
            <p className="item-detail-description">
              {HTMLReactParser(props.ItemDetailDescription)}
            </p>
            </Link>
{props.searchType === "sales" ?
<div className="item-user-details">
              {
                props.ContactNumber ?
                <span className="contact-number 1">
                <Link
                    href={`tel: ${uknumberformat(props.ContactNumber)}`}
                    className="hover-ef-call"
                  >
                 {property_rezise_images ? <ImageModule ImageSrc={property_rezise_images} attr={{ alt: props.ItemAddress }} ggfx_results={negoimagetransforms} imagename="team.Image.smallcontact" strapi_id={negoid} />
                //  <ImageTransform imagesources={property_rezise_images} renderer="srcSet" imagename='team.Image.smallcontact'
                //                                                         attr={{ alt: "", className: '' }}
                //                                                         imagetransformresult={processedImages} id={negoid} ></ImageTransform>
                                                                        :
                  <picture>
                    <img src={noImage} alt="" />
                  </picture>
              }
              </Link>
                  {/* {props.ContactNumber} */}
                  <Link
                    href={`tel: ${uknumberformat(props.ContactNumber)}`}
                    className="btn-text-link"
                  >
                    {uknumberformat(props.ContactNumber)}
                  </Link>
                </span>
                : ''
              }
              {props.Email ? <ModelForm page="search-result" ContactNumber={props.ContactNumber} Name={props.Name} mailid={props.Email} /> : null}
              <SaveItem type="property" pid={props.objectID} userObjects={props.userObjects} loaderEnable={false}>
                <span className="icon-round-box wishlist">
                  <span className="icon-wrap">
                    <i class="icon-wishlist-small icon-default"></i>
                    <i class="icon-wishlist-small icon-fill icon-saved"></i>
                  </span>
                  <span className="icon-text save-text">Save</span>
                  <span className="icon-text saved-text">Saved</span>
                </span>
              </SaveItem>
            </div>
:
            <div className="item-user-details">
              {/* {
                <span className="contact-number">
                <Link
                    href={`tel: ${uknumberformat('01865 722722')}`}
                    className="hover-ef-call"
                  >
                 {property_rezise_images ? <ImageTransform imagesources={property_rezise_images} renderer="srcSet" imagename='team.Image.smallcontact'
                  attr={{ alt: "", className: '' }}
                  imagetransformresult={processedImages} id={negoid} ></ImageTransform>
                  :
                  <picture>
                    <source media="(min-width:992px)" srcSet={props.UserImage1} />
                    <source media="(min-width:768px)" srcSet={props.UserImage1} />
                    <img src={props.UserImage1} alt="" />
                  </picture>
                  }
                </Link>
                <Link
                    href={`tel: ${uknumberformat('01865 722722')}`}
                    className="btn-text-link"
                  >
                    {uknumberformat('01865 722722')}
                </Link>
                </span>
              }

              {props.Email ? <ModelForm page="search-result" ContactNumber={props.ContactNumber} Name={props.Name} mailid={props.Email} /> : null} */}

              {
                props.officeId === "1" || props.officeId === "2" || props.officeId === "4" || props.officeId === "5" || true ?
                <span className="contact-number 2">
                <Link
                    href={`tel: ${uknumberformat(props.officeId === "1" || props.officeId === "4" || props.officeId === "5" || true ? officedata.glstrapi?.offices[0]?.Lettings_Phone : props.officeId === "2" ? officedata.glstrapi?.offices[1]?.Lettings_Phone : null )}`}
                    className="hover-ef-call"
                  >
                 {property_rezise_images ? <ImageModule ImageSrc={property_rezise_images} attr={{ alt: props.ItemAddress }} ggfx_results={negoimagetransforms} imagename="team.Image.smallcontact" strapi_id={negoid} />
                //  <ImageTransform imagesources={property_rezise_images} renderer="srcSet" imagename='team.Image.smallcontact'
                //                                                         attr={{ alt: "", className: '' }}
                //                                                         imagetransformresult={processedImages} id={negoid} ></ImageTransform>
                                                                        :
                  <picture
                  // className="icon-img-call"
                  >
                    <source media="(min-width:992px)" srcSet={props.UserImage1} />
                    <source media="(min-width:768px)" srcSet={props.UserImage1} />
                    <img src={props.UserImage1} alt="" />
                  </picture>
              }
              </Link>
                  {/* {props.ContactNumber} */}
                  <Link
                    href={`tel: ${uknumberformat(props.officeId === "1" || props.officeId === "4" || props.officeId === "5" || true ? officedata.glstrapi?.offices[0]?.Lettings_Phone : props.officeId === "2" ? officedata.glstrapi?.offices[1]?.Lettings_Phone : null)}`}
                    className="btn-text-link"
                  >
                    {uknumberformat(props.officeId === "1" || props.officeId === "4" || props.officeId === "5" || true ? officedata.glstrapi?.offices[0]?.Lettings_Phone : props.officeId === "2" ? officedata.glstrapi?.offices[1]?.Lettings_Phone : null)}
                  </Link>
                </span>
                : ''
              }
              {
              props.officeId === "1" || props.officeId === "2" || props.officeId === "4" || props.officeId === "5" || true ?
              <ModelForm page="search-result" ContactNumber={props.officeId === "1" || props.officeId === "4" || props.officeId === "5" ? officedata.glstrapi?.offices[0]?.Lettings_Phone : props.officeId === "2" ? officedata.glstrapi?.offices[1]?.Lettings_Phone : null } Name={props.officeId === "1" || props.officeId === "4" || props.officeId === "5" ? officedata.glstrapi?.offices[0]?.Office_Name : props.officeId === "2" ? officedata.glstrapi?.offices[1]?.Office_Name : null} mailid={props.officeId === "1" || props.officeId === "4" || props.officeId === "5" || true ? officedata.glstrapi?.offices[0]?.Office_Email : props.officeId === "2" ? officedata.glstrapi?.offices[1]?.Office_Email : null} />
               : null

              }
              {/* <span className="wishlist icon-round-box">
                <Link href="#">
                  <span className="icon-wrap">
                    <i className="icon-wishlist-small"></i>
                  </span>{" "}
                  <span className="icon-text d-none d-md-block">Save</span>
                </Link>
              </span> */}
              <SaveItem type="property" pid={props.objectID} userObjects={props?.userObjects} loaderEnable={false}>
                <span className="icon-round-box wishlist">
                  <span className="icon-wrap">
                    <i class="icon-wishlist-small icon-default"></i>
                    <i class="icon-wishlist-small icon-fill icon-saved"></i>
                  </span>
                  <span className="icon-text save-text">Save</span>
                  <span className="icon-text saved-text">Saved</span>
                </span>
              </SaveItem>
            </div>
            }
          </div>

        </div>
      {/* </ScrollAnimation> */}
      {/* {isFloorplanOpen && (
          <Lightbox
              mainSrc={lightImagesFloorplan[floorplanIndex]}
              nextSrc={lightImagesFloorplan[(floorplanIndex + 1) % lightImagesFloorplan.length]}
              prevSrc={lightImagesFloorplan[(floorplanIndex + lightImagesFloorplan.length - 1) % lightImagesFloorplan.length]}
              onCloseRequest={() => setIsFloorplanOpen(false)}
              onMovePrevRequest={() =>
                setFloorplanIndex((floorplanIndex + lightImagesFloorplan.length - 1) % lightImagesFloorplan.length)
              }
              onMoveNextRequest={() =>
                setFloorplanIndex((floorplanIndex + 1) % lightImagesFloorplan.length)
              }
          />
      )} */}
      {
        props.FloorplanImg &&
        <FsLightbox
          toggler={floorToggler}
          sources={[props?.FloorplanImg[0]?.srcUrl]}
          type='image'
        />
      }

      {
        lightImagesProperty &&
        <FsLightbox
          toggler={bannerToggler}
          sources={lightImagesProperty}
          type='image'
        />
      }
      {/* {isBannerOpen && (
          <Lightbox
              mainSrc={lightImagesProperty[photoIndex]}
              nextSrc={lightImagesProperty[(photoIndex + 1) % lightImagesProperty.length]}
              prevSrc={lightImagesProperty[(photoIndex + lightImagesProperty.length - 1) % lightImagesProperty.length]}
              onCloseRequest={() => setIsBannerOpen(false)}
              onMovePrevRequest={() =>
                  setPhotoIndex((photoIndex + lightImagesProperty.length - 1) % lightImagesProperty.length)
              }
              onMoveNextRequest={() =>
                  setPhotoIndex((photoIndex + 1) % lightImagesProperty.length)
              }
          />
      )} */}
      </UserObjectStoreProvider>
    </React.Fragment>
  );
};

export default NewTabSearch;
